import { PatientRepository } from 'repository/repositories/patient/patient-repository'
import { makeApiRepository } from 'main/factories/repositories/api-repository-factory'

export const makePatientRepository = (): PatientRepository => {
  return new PatientRepository(makeApiRepository())
}
